module.exports = __webpack_public_path__ + "./docs/img/icon-api_method.2982ca3593ad3fa44468d735d465e6f3.svg";